import { WarehousesActionTypes } from './constants';

type WarehousesBookAction = { type: string, payload: {} | string };

export const warehouseApiResponseSuccess = (actionType: string, data: any): WarehousesBookAction => ({
    type: WarehousesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const warehouseApiResponseError = (actionType: string, error: string): WarehousesBookAction => ({
    type: WarehousesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const warehouseGetAllWarehouses = (query: string): WarehousesBookAction => ({
    type: WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST,
    payload: { query },
});

export const warehouseCreateWarehouse = (warehouse: any, callback): WarehousesBookAction => ({
    type: WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST,
    payload: { warehouse, callback },
});

export const warehouseUpdateWarehouse = (warehouseId, warehouse: any): WarehousesBookAction => ({
    type: WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST,
    payload: { warehouseId, warehouse },
});

export const warehouseDeleteWarehouse = (warehouseId): WarehousesBookAction => ({
    type: WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST,
    payload: { warehouseId },
});

export const warehouseResetWarehouse = (): WarehousesBookAction => ({
    type: WarehousesActionTypes.RESET_STATE,
    payload: {},
});

export const warehouseResetAllErrors = (): WarehousesBookAction => ({
    type: WarehousesActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
